module.exports = __webpack_public_path__ + "img/full1-min.eba6ef55.png";